export const ROUTES = {
    CATEGORIES: '/alle-spil/kategorier',
    CATEGORY_DETAIL: '/alle-spil/kategorier/sort',
    PROVIDERS: '/alle-spil/spiludviklere',
    PROVIDERS_DETAIL: (providerName = ':provider') =>
        `/alle-spil/spiludviklere/${providerName}`,
}
